/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Scale_Desc5Inputs */

const en_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handles hundreds of sources and millions of pages with a proxy pool and workers that won't trip alarms.`)
};

const ar_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتعامل مع مئات المصادر وملايين الصفحات بمجموعة بروكسي ووحدات عمل لا تطلق الإنذارات.`)
};

const bn_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রক্সি পুল ও এমন ওয়ার্কার দিয়ে শত শত সোর্স ও কোটি পেজ সামলায় যারা অ্যালার্ম ট্রিগার করে না।`)
};

const de_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitet Hunderte von Quellen und Millionen von Seiten mit einem Proxy-Pool und Workern, die keine Alarme auslösen.`)
};

const es_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maneja cientos de fuentes y millones de páginas con un grupo de proxy y trabajadores que no activan alarmas.`)
};

const fr_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère des centaines de sources et des millions de pages avec un pool de proxy et des travailleurs qui ne déclencheront pas d'alarmes.`)
};

const pt_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lida com centenas de fontes e milhões de páginas com um pool de proxy e trabalhadores que não disparam alarmes.`)
};

const zh_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用代理池和不会触发告警的 worker，接几百个源、几百万页面。`)
};

const tr_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yüzlerce kaynağı ve milyonlarca sayfayı bir proxy havuzu ve alarmları tetiklemeyen çalışanlarla yönetir.`)
};

const ru_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обрабатывает сотни источников и миллионы страниц с помощью пула прокси и рабочих процессов, которые не активируют сигналы тревоги.`)
};

const pl_svc_web_scraping_scale_desc5 = /** @type {(inputs: Svc_Web_Scraping_Scale_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setki źródeł i miliony stron na puli proxy i workerach, które nie odpalają alarmów.`)
};

/**
* | output |
* | --- |
* | "Handles hundreds of sources and millions of pages with a proxy pool and workers that won't trip alarms." |
*
* @param {Svc_Web_Scraping_Scale_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_scale_desc5 = /** @type {((inputs?: Svc_Web_Scraping_Scale_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Scale_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_scale_desc5(inputs)
	if (locale === "bn") return bn_svc_web_scraping_scale_desc5(inputs)
	if (locale === "de") return de_svc_web_scraping_scale_desc5(inputs)
	if (locale === "es") return es_svc_web_scraping_scale_desc5(inputs)
	if (locale === "fr") return fr_svc_web_scraping_scale_desc5(inputs)
	if (locale === "pt") return pt_svc_web_scraping_scale_desc5(inputs)
	if (locale === "zh") return zh_svc_web_scraping_scale_desc5(inputs)
	if (locale === "tr") return tr_svc_web_scraping_scale_desc5(inputs)
	if (locale === "ru") return ru_svc_web_scraping_scale_desc5(inputs)
	if (locale === "pl") return pl_svc_web_scraping_scale_desc5(inputs)
	return en_svc_web_scraping_scale_desc5(inputs)
});
export { svc_web_scraping_scale_desc5 as "svc_web-scraping_SCALE_desc" }